export enum TAX_FORMIK_PATH_ENUM {
  TAXABLE_PERIODS = 'taxablePeriods',
}

export enum TAX_PAYMENT_PERIOD_TYPES_ENUM {
  QUARTERLY = 'quarterly',
  MONTHLY = 'monthly',
  NY_FISCAL = 'ny_fiscal_quarter',
}

export enum RENTAL_STRUCTURE_STATUS_ENUM {
  HIDDEN = 'hidden',
  REQUIRED = 'required',
  OPTIONAL = 'optional',
}

export enum UNIT_NUMBER_STATUS_ENUM {
  HIDDEN = 'hidden',
  REQUIRED = 'required',
  OPTIONAL = 'optional',
}

export enum BREAKPOINT_ENUM {
  SMALL = 576,
  MEDIUM = 768,
}

export enum DASHBOARD_ACTIONS_ENUM {
  BULK_TAX = 'bulkTax',
  SINGLE_RENEW = 'singleRenew',
  BULK_RENEW = 'bulkRenew',
}

export enum FLOWS_ENUM {
  APPLY_LICENSE = 'applyLicense',
  UPDATE_CERTIFICATE = 'updateCertificate',
  ADMIN_UPDATE = 'adminUpdate',
  RENEW_LICENSE = 'renewLicense',
  BULK_RENEWAL = 'bulkRenewal',
  PAY_TOT = 'payTot',
  TBID = 'tbid',
}

export enum PAYMENT_METHODS {
  ACH_DIRECT_DEBIT = 'achDirectDebit',
  CREDIT_OR_DEBIT__CARD = 'creditOrDebitCard',
  CHECK = 'check',
}

export enum PAYMENT_METHOD_LABEL_ENUM {
  none = 'None',
  credit_card = 'Credit Card',
  ach = 'ACH',
  check = 'Check',
  push_ach = 'ACH',
  ach_credit_transfer = 'ACH',
}

export enum PERMIT_SORT_OPTIONS_ENUM {
  ADDRESS_ASC = 'addressAsc',
  ADDRESS_DESC = 'addressDesc',
  PERMIT_NUMBER_ASC = 'permitNumberAsc',
  PERMIT_NUMBER_DESC = 'permitNumberDesc',
  EXPIRATION_DATE_ASC = 'expirationDateAsc',
  EXPIRATION_DATE_DESC = 'expirationDateDesc',
  OWNER_NAME_ASC = 'ownerNameAsc',
  OWNER_NAME_DESC = 'ownerNameDesc',
  STATUS_ASC = 'statusAsc',
  STATUS_DESC = 'statusDesc',
}

export enum INPUT_TYPE {
  NUMBER = 'number',
  TEXT = 'text',
  TEXTAREA = 'textarea',
}

export enum FORM_INPUT_TYPES {
  EMAIL = 'email',
  NUMBER = 'number',
  CURRENCY = 'currency',
  PHONE = 'phone',
  TEXT = 'text',
}

export const RENTAL_STRUCTURE_DISPLAY_NAME_DICT = {
  main_structure: 'Main Structure',
  adu: 'ADU',
  apartment: 'Apartment',
  single_family_dwelling: 'Single Family Dwelling',
  duplex: 'Duplex',
  townhome: 'Townhome',
  condo: 'Condo',
  accessory_structure: 'Accessory Structure',
  bed_and_breakfast: 'Bed and Breakfast',
  cottage: 'Cottage',
  cabin: 'Cabin',
  campground: 'Campground',
  chalet: 'Chalet',
  guesthouse: 'Guesthouse',
  hotel: 'Hotel',
  lodge: 'Lodge',
  motel: 'Motel',
  private_studio: 'Private Studio',
  rv_park: 'RV Park',
  time_share: 'Time Share',
  unit1: 'Unit 1',
  unit2: 'Unit 2',
  unit3: 'Unit 3',
  other: 'Other',
};

export enum MULTIPLE_PERMITS_PER_APN_POLICY_OPTIONS_ENUM {
  BLOCK = 'block',
  WARN = 'warn',
  ALLOW = 'allow',
}

export enum ALL_PERMITS_STATUS_OPTIONS_ENUM {
  ALL = 'all',
  ACTIVE = 'Active',
  INACTIVE = 'inactive',
}

export enum ADMIN_UPDATE_ACCOUNT_OPTIONS_ENUM {
  NEWACCOUNT = 'newAccount',
  MOVETOEXISTINGACCOUNT = 'moveToExistingAccount',
  NOCHANGE = 'noChange',
}
